import endpoints from './endpoints';
import request from './request';

const supplierApi = {
    initialize(companyId) {
        return request.get(
            endpoints.supplier.initialize(companyId),
        );
    },

    upload(companyId, formData) {
        return request.postFile(
            endpoints.supplier.upload(companyId),
            formData,
        );
    },

    generate(companyId, data) {
        return request.post(
            endpoints.supplier.generate(companyId),
            data,
        );
    },

    generateExcel(companyId, formData) {
        return request.postFile(
            endpoints.supplier.generateExcel(companyId),
            formData,
        );
    },

    download(companyId, fileName) {
        return request.download(
            endpoints.supplier.download(companyId),
            {
                name: fileName,
            },
        );
    },

    downloadUrl(companyId) {
        return endpoints.supplier.download(companyId).replace(/^\/+/, '');
    },

};

export default supplierApi;


// WEBPACK FOOTER //
// ./src/api/supplierApi.js